import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-survey-preview',
  templateUrl: './survey-preview.component.html',
  styleUrls: ['./survey-preview.component.css']            
})
export class SurveyPreviewComponent implements OnInit {
  allSelectedQuestions : any  = JSON.parse(sessionStorage.getItem("allSelectedQuestions"));
  stdQuestionAnswers : any = JSON.parse(sessionStorage.getItem("stdQuestionAnswers"));
  selectedAnswers : any = [];
  surveyDetail = JSON.parse(sessionStorage.getItem("surveyDetails"));
  eventDetails : any = JSON.parse(sessionStorage.getItem("eventDetails"));
  eventName :string = this.eventDetails.eventName;
  msg1:string;
  previewMethod :string;
  landingData:any;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId : number = this.loginData.userId;
  loginUserName  = `${this.loginData.userFirstName} ${this.loginData.userLastName}`;
  alertSuccess: boolean;
  adminId:any = localStorage.getItem('adminId');
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  isbpgAdmin = false;
  isbpgLeadAdmin = false;
  constructor(private readonly router: Router,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    private readonly bpgEventsService : BpgEventsService,
    
    private readonly environment : EnvironmentConfiguration) { }

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
   if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
    }}
    
    if(localStorage.getItem('isbpgAdmin') === 'true')
    {
      this.isbpgAdmin = true
    }
    if(localStorage.getItem('isbpgLeadAdmin') === 'true')
    {
      this.isbpgLeadAdmin = true
    }
   if(this.adminId !== '1' && this.adminId !== '2' && this.adminId !== '3' && !this.isbpgAdmin && !this.isbpgLeadAdmin)
    {
      this.router.navigate(['/site-home']);
    }
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
   
    this.spinnerService.show();

    for(const i of this.allSelectedQuestions){
      for(const j of this.stdQuestionAnswers){
        if(i.questionId === j.questionId ){
            this.selectedAnswers.push(i);
      }
    }

    setTimeout(function(){
      this.spinnerService.hide();
    }.bind(this), 1500);
    
  }
}

/** to select cancel
   * @class SurveyPreviewComponent
   * @method cancelClick
   */
  cancelClick(){
    this.previewMethod = "navigate";
    this.msg1=" Are you sure you want to leave this page ?";
  }
  navigate(){
    this.router.navigate(['/create-survey']);
  }

  /** to submit survey
   * @class SurveyPreviewComponent
   * @method submit
   */
  launch(){

    document.getElementById("launchButton").setAttribute('data-toggle','modal');
    document.getElementById("launchButton").setAttribute('data-target','#myModal');
    this.previewMethod = "submit";
    this.msg1=" Are you sure you want to launch survey ?";
    
  }

  submit(){
    this.spinnerService.show();
    this.landingData= {
      "createdBy": this.loginUserName, 
      "endDate": this.surveyDetail[1],
      "eventId": this.eventDetails.eventId,
      "isActive": true,
      "modifiedBy": this.loginUserName,
      "startDate": this.surveyDetail[0],
      "surveryDesc": this.surveyDetail[2],
      "surveyLaunchAdmin": this.loginUserId,
      "surveyQuestions": [
       
      ]
    }
    
    for(const ans of this.selectedAnswers){
      this.landingData.surveyQuestions.push(
        {
          "createdBy": this.loginUserName,      
          "isActive": true,
          "modifiedBy": this.loginUserName,   
          "survey": {           
          },
          "surveyQuestion": {            
            "surveyQuestionId": ans.questionId
          },
          "surveyQuestionId":  ans.questionId
        }
      )
    }
    this.bpgEventsService.createSurvey(this.landingData).subscribe(_data=>{
      this.spinnerService.hide();
      this.alertSuccess = true;
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      setTimeout(function() {         
        this.alertSuccess = false;
        this.router.navigate(['/event-view-details']);
      }.bind(this), 6000 );

    })
  }

}
